import { Component, Input, OnChanges } from '@angular/core';
import { ComponentData } from '@ddt-web/data-service';

import { AlertConstants } from '../alert/alert.constants';
import { EntityFlags } from '../utils/entity-flags';
import { PartnerPortfolioFlagUtils } from '../utils/partner-portfolio-flag-utils';

@Component({
	selector: 'pi-customized-portfolio-alerts',
	templateUrl: './customized-portfolio-alerts.component.html',
	styleUrls: ['./customized-portfolio-alerts.component.scss']
})
export class CustomizedPortfolioAlertsComponent implements OnChanges {

	@Input() public data: ComponentData;
	@Input() public portfolioId;
	@Input() public portfolioIndex;
	@Input() public portfolioDirtyFlags: Array<string> = new Array<string>();

	public AlertConstants = AlertConstants;
	public portfolioFlags: Array<EntityFlags> = new Array<EntityFlags>();

	public isViewOnly: boolean;
	public hasPortfolioDirtyFlag: boolean;

	public ngOnChanges(): void {
		if (this.data.success && this.data.portfolioData) {
			this.portfolioFlags = PartnerPortfolioFlagUtils.populatePartnerPortfolioFlags(this.data);
			this.hasPortfolioDirtyFlag = this.portfolioDirtyFlags.includes(this.portfolioId);
			this.isViewOnly = !this.hasPortfolioDirtyFlag && PartnerPortfolioFlagUtils.isViewOnly(this.portfolioFlags[this.portfolioIndex]);
		}
	}
}
